/**
 * Protected Route Component
 * Wraps routes that require authentication
 * Uses Zustand auth store
 */

import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthStore from '../utils/stores/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading, user, fetchUser } = useAuthStore();
  const location = useLocation();

  // Fetch user if authenticated but no user data
  useEffect(() => {
    if (isAuthenticated && !user && !isLoading) {
      fetchUser().catch(() => {
        // If fetch fails, user will be redirected to login
      });
    }
  }, [isAuthenticated, user, isLoading, fetchUser]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // Save the location they were trying to access
    sessionStorage.setItem('returnTo', location.pathname);
    
    // Redirect to login
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
